module.exports = __webpack_public_path__ + "static/media/missing avatars.b9ff2a2a.txt";